import { page } from '$app/state';
import { globalState } from '#lib/util/global-state.svelte.ts';
import { translations, type I18nKey, type Locale } from './translations';

class Translator {
	locale = $derived.by(() => {
		// Antonio instance: instance defined language
		const instance = globalState.instance;
		if (instance?.type === 'antonio' && instance.language) {
			return instance.language;
		}

		// Logged-in user: their account setting.
		const userLocale = page.data.loggedInUser?.locale;
		if (userLocale) {
			return userLocale;
		}

		// Anyone else: the browser's preferred language, German as fallback.
		const browserPreferred = navigator?.languages[0].split('-')[0];
		return (browserPreferred || 'de') as Locale;
	});
	translate = $derived((key: I18nKey, vars: Record<string, string | number> = {}) => {
		const localeTranslations = translations[this.locale] || translations.de;
		const template = localeTranslations[key] || translations.de[key] || `${key}-i18n-missing`;

		const text = Object.entries(vars).reduce((accT, [key, value]) => {
			const regex = new RegExp(`{{${key}}}`, 'g');
			return accT.replace(regex, '' + value);
		}, template);

		return text;
	});
}

export const translator = new Translator();

/**
 * Convenince for templates
 * @param key
 * @param vars
 * @returns
 */
export function t(key: I18nKey, vars: Record<string, string | number> = {}) {
	return translator.translate(key, vars);
}
